"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValue = exports.isTable = exports.isJsonStore = void 0;
/**
 * IsJsonSQLite
 * @param obj
 */
const isJsonStore = (obj) => {
    const keyFirstLevel = ["database", "encrypted", "tables"];
    if (obj == null ||
        (Object.keys(obj).length === 0 && obj.constructor === Object))
        return false;
    for (const key of Object.keys(obj)) {
        if (keyFirstLevel.indexOf(key) === -1)
            return false;
        if (key === "database" && typeof obj[key] != "string")
            return false;
        if (key === "encrypted" && typeof obj[key] != "boolean")
            return false;
        if (key === "tables" && typeof obj[key] != "object")
            return false;
        if (key === "tables") {
            for (const oKey of obj[key]) {
                const retTable = (0, exports.isTable)(oKey);
                if (!retTable)
                    return false;
            }
        }
    }
    return true;
};
exports.isJsonStore = isJsonStore;
/**
 * IsTable
 * @param obj
 */
const isTable = (obj) => {
    const keyTableLevel = ["name", "values"];
    if (obj == null ||
        (Object.keys(obj).length === 0 && obj.constructor === Object)) {
        return false;
    }
    for (const key of Object.keys(obj)) {
        if (keyTableLevel.indexOf(key) === -1)
            return false;
        if (key === "name" && typeof obj[key] != "string")
            return false;
        if (key === "values" && typeof obj[key] != "object")
            return false;
        if (key === "values") {
            for (const oKey of obj[key]) {
                const retValue = (0, exports.isValue)(oKey);
                if (!retValue)
                    return false;
            }
        }
    }
    return true;
};
exports.isTable = isTable;
/**
 * IsValue
 * @param obj
 */
const isValue = (obj) => {
    const keyTableLevel = ["key", "value"];
    if (obj == null ||
        (Object.keys(obj).length === 0 && obj.constructor === Object)) {
        return false;
    }
    for (const key of Object.keys(obj)) {
        if (keyTableLevel.indexOf(key) === -1)
            return false;
        if (key === "key" && typeof obj[key] != "string")
            return false;
        if (key === "value" && typeof obj[key] != "string")
            return false;
    }
    return true;
};
exports.isValue = isValue;
//# sourceMappingURL=json-utils.js.map